import log from 'Utilities/log';
import { setSessionObject } from './storage';
// TODO: change how to add the connections
const setConnections = (connections) => {
    setSessionObject('connections', connections);
    log.info('Success! Refresh your page.');
};
window.testHelper = {
    setConnections,
};
